import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { currentUser } from 'redux/session/selectors';
import { fetchIUserStart } from 'redux/iuser/actions';
import {
  Button,
  Link,
  RadioButtonGroup,
  RadioButton
} from 'carbon-components-react';
import { phoneNumberFormatter } from 'utilities/validation';

const UserDetails = ({ setIsDetailsModalOpen, user }: any) => {
  const [isMultiOrganisations, setIsMultiOrganisations] = useState<boolean>(
    false
  );
  const [IUserOrgId, setIUserOrgId] = useState<number | undefined>();
  const dispatch: any = useDispatch();
  const { role } = useSelector(currentUser);
  const impersonateUserHandler = async () => {
    dispatch(fetchIUserStart({ userId: user.id, organisationId: IUserOrgId }));
  };

  useEffect(() => {
    setIsMultiOrganisations(
      Array.isArray(user.organisations) && user.organisations.length > 1
    );
  }, [user]);

  const userPhoneNumber = user?.phoneNumber
    ? phoneNumberFormatter({
        phoneNumber: user.phoneNumber
      }).getNationalNumberFormat()
    : null;
  return (
    <div className="search-per-user-filter ">
      <section className="search-per-user-filter-main">
        <div className="search-per-user-filter-main-div">
          <div className="search-per-user-heading">User</div>
          <hr className="search-per-user-divider" />
          <div className="search-per-user-firstName">
            {user.firstName} {user.lastName}
          </div>
          <Link
            className="search-per-user-email"
            href={`mailto: ${user.email}`}
          >
            {user.email}
          </Link>
          <div className="search-per-user-phone">{userPhoneNumber}</div>
          {user.address && (
            <div className="search-per-user-address-line1">
              {user.address?.line1} {user.address?.line2}
            </div>
          )}
          {user.address && (
            <div className="search-per-user-address-line2">{`${user.address?.locality} ${user.address?.state} ${user.address?.postcode}`}</div>
          )}
          {user.companyName && (
            <>
              <div className="search-per-user-address-alternate-email">
                Company name
              </div>
              <div className="search-per-user-address-line2">
                {user.companyName}
              </div>
            </>
          )}
          {user.alternateEmail && (
            <>
              <div className="search-per-user-address-alternate-email">
                Alternate email
              </div>
              <div className="search-per-user-email">{user.alternateEmail}</div>
            </>
          )}
          <hr className="search-per-user-divider" />
          <div className="search-per-user-address-created">Created</div>
          <div className="search-per-user-address-createdDate">
            {user.createdAt}
          </div>
          <div className="search-per-user-address-last-login ">Last login</div>
          <div className="search-per-user-address-createdDate">
            {user.lastLoggedInAt || 'Never'}
          </div>
          {user.role?.toUpperCase() !== 'ENQUIRER' && (
            <>
              <div className="search-per-user-organisation-membership">
                Organisation memberships
              </div>
              {isMultiOrganisations ? (
                <RadioButtonGroup
                  name="org-user-radio-button-group"
                  labelPosition="right"
                  orientation="vertical"
                  onChange={(value: number) => setIUserOrgId(value)}
                >
                  {user.organisations.map((item: any, inx: number) => (
                    <RadioButton
                      key={inx}
                      id={`org-user-radio-${inx}`}
                      labelText={`${item.name} ${
                        item.utilityId ? `(${item.utilityId})` : ''
                      }`}
                      value={item.id}
                    />
                  ))}
                </RadioButtonGroup>
              ) : (
                <>
                  {user.organisations.map((item: any, inx: number) => (
                    <div
                      key={inx}
                      className="search-per-user-organisation-members"
                    >
                      {item.name}
                    </div>
                  ))}
                </>
              )}
            </>
          )}
          <hr className="search-per-user-divider" />
          {role.toUpperCase() === 'SYSADMIN' &&
            user.role.toUpperCase() !== 'SYSADMIN' && (
              <>
                <Button
                  kind="tertiary"
                  className="search-user-impersonate-button"
                  onClick={impersonateUserHandler}
                  disabled={isMultiOrganisations && !IUserOrgId}
                >
                  Impersonate this user
                </Button>
                <div className="search-per-user-impersonate-text">
                  Impersonation tokens expire after 30 minutes, but you can
                  renew at any time. An audit log is recorded of all user
                  impersonation sessions.
                </div>
              </>
            )}
        </div>
        <Button
          kind="secondary"
          className="search-per-user-done"
          onClick={() => setIsDetailsModalOpen(false)}
        >
          Done
        </Button>
      </section>
    </div>
  );
};
export default UserDetails;
